import { getKeycloak } from './keycloak-instance';
import { resetMixpanelAnonymousId } from '@/mixpanel-anonymous-id';

/**
 * EU-642 (RN-09) — helper ÚNICO de logout do candidato.
 *
 * TODO logout passa por aqui: o id anônimo do Mixpanel é DESCARTADO antes do
 * redirect do Keycloak, então o próximo usuário neste dispositivo nasce com um
 * `$device_id` fresco e nunca é fundido ao anterior
 * (errAnonDistinctIdAssignedAlready — INC-01).
 *
 * INC-01 round 2: RN-09 valia só no logout do AppHeader; Perfil ("Sair") e
 * onboarding deslogavam direto pelo `getKeycloak().logout()` e o id vazava.
 * NÃO chame `getKeycloak().logout()` direto em superfícies do candidato —
 * use este helper (o guard de regressão em logout.test.ts pina o contrato).
 */
export function logoutCandidate(options?: { redirectUri?: string }): void {
  resetMixpanelAnonymousId();
  if (options) {
    void getKeycloak().logout(options);
  } else {
    void getKeycloak().logout();
  }
}
